import * as React from 'react';
import { Innovation } from '@shapeable/copper-connect-types';

export const InnovationsContext = React.createContext<Innovation[]>(null);
export const InnovationsProvider = InnovationsContext.Provider;